import { createFileRoute } from '@tanstack/react-router';
import { DraftPage } from '@/features/metric-hub/drafts/DraftPage';

/**
 * Draft review route (read mode).
 *
 * Index leaf of the `drafts.$slug.$draftId` layout. Sibling of `.edit`
 * — the layout file renders `<Outlet />` and TanStack Router picks
 * which leaf to mount based on whether `/edit` is appended.
 *
 * URL: `/metric-hub/drafts/<slug>/<draftId>` (no trailing /edit).
 */
export const Route = createFileRoute('/_authed/metric-hub/drafts/$slug/$draftId/')({
  component: DraftRoute,
});

function DraftRoute() {
  const { slug, draftId } = Route.useParams();
  return <DraftPage slug={slug} draftId={draftId} />;
}
